// @ts-nocheck
import { httpClient } from '../../../core/network';
import { Household, HouseholdLogsResponse } from '../types';

class HouseholdService {
  private static lang = localStorage.getItem('i18nextLng') || 'en';
  private static header = { 'Language': this.lang };

  static fetchHousehold(userId: string): Promise<Household> {
    const apiUrl = `customers/${userId}/household`;
    return httpClient.get(apiUrl, { headers: this.header });
  }

  static fetchHouseholdLogs(userId: string): Promise<HouseholdLogsResponse> {
    const apiUrl = `customers/${userId}/household/logs`;
    return httpClient.get(apiUrl, { headers: this.header });
  }

  static performActionOnDevice(actionUrl: string) {
    const apiUrl = `customers/household/action`;
    return httpClient.post(
      apiUrl,
      { 'actionUrl': actionUrl },
      { headers: this.header }
    );
  }
}

export default HouseholdService;
